<template>
  <div class="container article">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>评论管理</el-breadcrumb-item>
        <el-breadcrumb-item>笔记评论</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">笔记评论</h2>
        </div>

      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="发布人"
                      prop="name">
          <el-input v-model="query.create_user_keyword"
                    placeholder="请输入发布人关键字 昵称/姓名/手机号"
                    style="width: 200px"
                    @input="getList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="发布人身份"
                      prop="status">
          <el-select v-model="create_user_educate_types"
                     placeholder="请选择"
                     clearable
                     @change="getList(true)"
                     style="width:100px;">
            <el-option v-for="item in filter.educate_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论内容"
                      prop="name">
          <el-input v-model="query.content_keyword"
                    placeholder="请输入评论内容"
                    style="width: 200px"
                    @input="getList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="评论层级"
                      prop="status">
          <el-select v-model="query.levels "
                     placeholder="请选择"
                     clearable
                     @change="getList(true)"
                     style="width:100px;">
            <el-option v-for="item in filter.type_levels "
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="发布人身份"
                      prop="name">
          <el-input v-model="query.author_user_id"
                    placeholder="输入发布人身份"
                    style="width: 200px"
                    clearable></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="评论层级"
                      prop="name">
          <el-input v-model="query.content_keyword"
                    placeholder="请输入评论层级"
                    style="width: 200px"
                    clearable></el-input>
        </el-form-item> -->
      </el-form>
    </div>

    <div class="results card">
      <div class="table-header">
        <h3 class="title">评论列表</h3>
      </div>

      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           align="center"> </el-table-column>
          <el-table-column prop="id"
                           width="80"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column label="发布人"
                           width="180"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleLookUser(scope.row.create_user_obj.id)"
                       v-if="scope.row.create_user_obj">{{ scope.row.create_user_obj.nickname }} </el-link>
              <span v-if="scope.row.create_user_virtual_type==1"
                    class="virBtn">虚拟</span>

            </template>
          </el-table-column>
          <el-table-column label="评论内容"
                           align="left"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.content }}</span></template>
          </el-table-column>
          <el-table-column label="评论层级"
                           width="70"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.level }}层</span>
            </template>
          </el-table-column>
          <el-table-column label="点赞量"
                           width="100"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#409EFF; cursor: pointer;"
                    @click="handleClick(scope.row)">{{ scope.row.like_count }}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态"
                           width="90"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.hide_status==0"
                      type="success">正常</el-tag>
              <el-tag v-if="scope.row.hide_status==1"
                      type="danger">隐藏</el-tag>

            </template>
          </el-table-column>
          <el-table-column label="发布时间"
                           align="center"
                           width="200"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm:ss")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="80"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleLook(scope.row)">查看</el-link>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="danger"
                   @click="handleDelete()">批量删除</el-button>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="评论审核"
               :visible.sync="noteShow"
               @close="handleClose()"
               width="950px">
      <div class="auditContent">
        <div class="iframContent">
          <iframe :src="currentSrc"
                  width="300px"
                  frameborder="1"
                  style=" border: 1px solid black;"
                  height="600px"
                  @load="handleIframeLoad"></iframe>
        </div>

        <div class="formRight">
          <div class="rightTop"
               style="display:flex;align-items: center;">
            <p style=" width: 4px;height: 15px;
 background: #1f86fe;
    border-radius: 4px 4px 4px 4px;marginRight:10px"></p>
            <p>评论信息</p>
          </div>
          <div class="commentmMess"
               style="border:none">
            <div class="commentItem"
                 style="border-top:1px solid #dcdfe6;border-left:1px solid #dcdfe6;border-right:1px solid #dcdfe6;">
              <div class="itemLeft">评论发布人</div>
              <div class="itemRight">{{detailRow.create_user_obj?detailRow.create_user_obj.nickname:''}}</div>
            </div>
            <div class="commentItem"
                 style="border-left:1px solid #dcdfe6;border-right:1px solid #dcdfe6;">
              <div class="itemLeft">评论内容</div>
              <div class="itemRight">{{detailRow.content}}</div>
            </div>
            <div class="commentItem"
                 style="border-left:1px solid #dcdfe6;border-right:1px solid #dcdfe6;">
              <div class="itemLeft">评论发布时间</div>
              <div class="itemRight">{{$moment(detailRow.create_time).format('YYYY-MM-DD hh:mm')}}</div>
            </div>

          </div>
          <div class="rightTop"
               style="display:flex;align-items: center;marginTop:20px">
            <p style=" width: 4px;height: 15px;
 background: #1f86fe;
    border-radius: 4px 4px 4px 4px;marginRight:10px;"></p>
            <p>评论审核</p>
          </div>

          <el-form :model="form"
                   :rules="rules"
                   ref="formRules"
                   label-width="80px"
                   style="margin-top:20px">
            <el-form-item label="关联积分"
                          prop="check_send_point">
              <div class="sendPoint">
                <div class="pointItem"
                     v-for="(item,index) in filter.points"
                     :key="index"
                     :class="{'point-other':currentIndex==index}"
                     @click="handlePoint(index,item)">{{item.label}}</div>
              </div>
            </el-form-item>
            <el-form-item label="选择基础点赞量区间"
                          label-width="86px">
              <div class="rangeContent">
                <div v-for="(item,index) in NumRanges"
                     :key="index"
                     class="rangeItem"
                     :class="{'active':item.flag}"
                     @click="handleLike(item)">{{item.label}}

                  <img src="https://upload.kaoyanbox.net/0474a5bcc4fed067ae81ab68267e6c68.png"
                       class="checkImg"
                       v-if="item.flag" />

                </div>
              </div>
            </el-form-item>

            <el-form-item label="是否隐藏"
                          prop="status">
              <el-switch v-model="form.status"></el-switch>
              <span class="hidden">开启后，该评论将对所有用户不可见</span>
            </el-form-item>

          </el-form>

          <span slot="footer"
                class="dialog-footer"
                style="float:right">
            <el-button @click="noteShow = false">取 消</el-button>
            <el-button type="primary"
                       @click="noteSubmit('formRules')">确 定</el-button>
          </span>

        </div>
      </div>
    </el-dialog>

    <LookUpvote :isVisible="upvoteVisible"
                @close="upvoteClose()"
                :detailId="detailId"
                :total_like_count="total_like_count"
                :type="types" />
    <UserDetail :visible="seniorVisible"
                :rowId="rowId"
                @close="seniorClose()"
                :editFlag="editFlag" />

  </div>

</template>

<script>
import {
  noteAdminList,
  noteDetail,
  noteCommentDelete,
  commentCheck,
  commentPut,
} from '@/api/senior'
import LookUpvote from '@/components/dialog/lookUpvote'
import UserDetail from '@/components/dialog/senior/userDetail'
export default {
  components: { LookUpvote, UserDetail },
  data() {
    return {
      create_user_educate_types: '',
      auditShow: false,
      createDatetime: '',
      currentSrc: '',
      noteShow: false,
      editShow: false,
      query: {
        content_keyword: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      chooseList: [],
      detailRow: {},
      filter: {
        educate_types: [
          { label: '学生', value: '0' },
          { label: '学长', value: '1' },
          { label: '虚拟学生', value: '3' },
          { label: '虚拟学长', value: '4' },
        ],
        type_levels: [
          { label: '一级', value: '1' },
          { label: '二级', value: '2' },
        ],
        points: [
          { label: '-5分', value: '-5' },
          { label: '1分', value: '1' },
          { label: '2分', value: '2' },
          { label: '5分', value: '5' },
        ],
      },
      form: { status: 1 },
      rules: {},
      currentIndex: 1,
      currentItem: {},
      NumRanges: [
        { id: 1, label: '0-10个', minHours: 0, maxHours: 10, flag: true },
        { id: 2, label: '11-30个', minHours: 11, maxHours: 30, flag: false },
        { id: 3, label: '31-60个', minHours: 31, maxHours: 60, flag: false },
        { id: 4, label: '61-100个', minHours: 61, maxHours: 100, flag: false },
      ],
      selectedRange: null,
      rangeNum: 0,
      upvoteVisible: false,
      total_like_count: 0,
      detailId: null,
      types: '评论',
      seniorVisible: false,
      rowId: null,
      editFlag: false,
    }
  },
  created() {
    this.getList()
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf()
        this.query.end_create_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.startcreate_time = ''
        this.query.end_create_time = ''
      }
    },
  },
  methods: {
    handleLookUser(id) {
      this.rowId = id
      this.seniorVisible = true
    },
    seniorClose() {
      this.seniorVisible = false
    },
    upvoteClose() {
      this.upvoteVisible = false
      this.getList(true)
    },
    handleLike(range) {
      range.flag = !range.flag
      if (range.flag) {
        this.NumRanges.map((item) => {
          if (item.id != range.id) {
            item.flag = false
          }
        })
      }
    },
    handleClick(row) {
      this.detailId = row.id
      this.total_like_count = row.like_count
      this.upvoteVisible = true
    },
    creatComment() {
      this.commentDialog = true
    },
    commentClose() {
      this.commentDialog = false
    },
    noteSubmit() {
      let hasOutOfStock = this.NumRanges.some(function (product) {
        return product.flag == true // 检查是否有库存为 0 的商品
      })
      if (hasOutOfStock) {
        let checkItem = null
        this.NumRanges.map((item) => {
          if (item.flag) {
            checkItem = item
          }
        })
        this.selectedRange = checkItem
        const { minHours, maxHours, label } = checkItem
        this.rangeNum =
          Math.floor(Math.random() * (maxHours - minHours + 1)) + minHours
        commentPut({
          note_comment_id: this.detailRow.id,
          base_like_count: this.rangeNum,
        }).then((res) => {})
      }

      let data = {
        note_comment_id: this.detailRow.id,
        hide_status: this.form.status ? 1 : 0,
        check_send_point: this.filter.points[this.currentIndex].value * 1,
      }
      commentCheck(data).then((res) => {
        this.$message.success('操作成功')
        this.handleClose()
        this.getList()
      })
    },
    handleClose() {
      this.noteShow = false
      this.currentSrc = ''
      // this.form.rejection = ''
      // this.form.auditRadio = 1
      this.currentIndex = 0
      this.NumRanges = [
        { id: 1, label: '0-10个', minHours: 0, maxHours: 10, flag: true },
        { id: 2, label: '11-30个', minHours: 11, maxHours: 30, flag: false },
        { id: 3, label: '31-60个', minHours: 31, maxHours: 60, flag: false },
        { id: 4, label: '61-100个', minHours: 61, maxHours: 100, flag: false },
      ]
    },
    handleIframeLoad() {},
    handleEdit() {},
    handlePoint(index, item) {
      this.currentIndex = index
      this.currentItem = item
    },
    timechange(e) {
      if (e == null) {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
      }
      this.getList(true)
    },
    handleLook(row) {
      console.log('row', row)
      if (location.host.includes('admin.kaoyanbox.com')) {
        this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/experienceDatail/index?id=${
          row.note_obj ? row.note_obj.id : row.note_id
        }`
      } else {
        this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/experienceDatail/index?id=${
          row.note_obj ? row.note_obj.id : row.note_id
        }`
      }

      this.form.status = row.hide_status == 1 ? true : false
      this.noteShow = true
      this.detailRow = row
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    getList(reset) {
      if (reset) {
        this.query.pageIndex = 1
      }
      if (this.create_user_educate_types == '3') {
        this.query.create_user_educate_types = '0'
        this.query.create_user_virtual_type = '1'
      } else if (this.create_user_educate_types == '4') {
        this.query.create_user_educate_types = '1'
        this.query.create_user_virtual_type = '1'
      } else {
        if (this.create_user_educate_types != '') {
          this.query.create_user_virtual_type = '0'
          this.query.create_user_educate_types = this.create_user_educate_types
        } else {
          this.query.create_user_virtual_type = ''
          this.query.create_user_educate_types = ''
        }
      }
      noteAdminList(this.query).then((res) => {
        this.pageTotal = res.count
        this.results = res.list
      })
    },
    // 删除
    toDetele(ids) {
      noteCommentDelete({
        ids: ids,
      }).then((res) => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    handleDelete(row) {
      if (this.chooseList.length == 0 && row == undefined) {
        this.$message.error('还没有选择要删除的数据')
      } else {
        this.$confirm('确定要删除这些评论吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let ids = []
          if (row) {
            ids.push(row.id)
          } else {
            this.chooseList.map((item) => {
              ids.push(item.id)
            })
          }

          this.toDetele(ids)
        })
      }
    },
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.getList()
    },
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getList()
    },
  },
}
</script>

<style scoped lang="less">
.article {
  .virBtn {
    display: inline-block;
    text-align: 34px;
    width: 34px;
    font-size: 10px;
    height: 22px;
    line-height: 22px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #cccccc;
  }
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      // justify-content: flex-end;
      justify-content: space-between;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
.tag-wrap {
  text-align: left;
  width: 100%;
  min-height: 30px;
}
.el-tag {
  margin: 0px 5px;
}
.auditContent {
  width: 900px;
  display: flex;
  justify-content: space-between;
  padding-left: 32px;
  .iframContent {
  }
  .formRight {
    .rangeContent {
      width: 400px;
      display: flex;
      flex-flow: wrap;

      .rangeItem {
        cursor: pointer;
        margin-bottom: 16px;
        margin-right: 20px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #dcdcdc;
        padding: 0px 4px;
        position: relative;
        .checkImg {
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: 14.16px;
          height: 12.5px;
        }
      }
      .active {
        border: 1px solid #1f86fe;
      }
    }
    .commentmMess {
      margin-top: 24px;
      width: 501px;
      // height: 174px;
      border: 1px solid #dcdfe6;
      .commentItem {
        width: 100%;
        display: flex;
        min-height: 40px;
        background: #fff;
        border-bottom: 1px solid #dcdfe6;
        .itemLeft {
          font-size: 14px;
          text-align: center;
          line-height: 40px;
          width: 120px;
          min-height: 40px;
          background: #f2f6fc;
        }
        .itemRight {
          padding-left: 8px;
          width: 401px;
          font-size: 14px;
          height: 100%;
          text-align: left;
          line-height: 40px;
        }
      }
    }
    .hidden {
      margin-left: 8px;
      font-size: 12px;
      color: #333333;
    }
    .sendPoint {
      display: flex;
      .pointItem {
        margin-right: 10px;
        text-align: center;
        width: 58px;
        height: 28px;
        font-size: 12px;
        line-height: 28px;
        background: #feffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #dcdcdc;
      }
      .point-other {
        font-size: 12px;
        border: none;
        color: #0052d9;
        background: url('https://upload.kaoyanbox.net/8bedfc7f6fb70fe51ea4a04d776b5416.png')
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
